/**
 *
 * TimeSpanPlannerPage
 *
 */
import {Component, createRef} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import AppContainer from "components/AppContainer/AppContainer";
import MultiStep from "components/MultiStep/MultiStep";
import history from "utils/history";
import * as PropTypes from "prop-types";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import ModalHeader from "basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import ForegroundBlob from "basicComponents/ForegroundBlob/ForegroundBlob";
import TimeSlotPlannerStep from "./steps/TimeSlotPlannerStep/TimeSlotPlannerStep";
import TimeSlotResultStep from "./steps/TimeSlotResultStep/TimeSlotResultStep";
import makeSelectTimeSpanPlannerPage from "./selectors";
import reducer from "./reducer";
import saga from "./saga";
import messages from "./messages";
import {resetAction} from "./actions";

export class TimeSlotPlanner extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
  };

  multiStepRef = createRef();

  state = {
    timeSlotId: -1,
    currentStep: 0,
  };

  componentDidMount() {
    this.props.reset();
    this.setTimeSlotId();
  }

  setTimeSlotId() {
    const timeSlotId = this.getExistingTimeSlot();
    if (timeSlotId !== -1) {
      this.setState({
        timeSlotId,
      });
    }
  }

  getExistingTimeSlot() {
    if (this.props.match.params.timeSlotId) {
      const parsed = Number.parseInt(this.props.match.params.timeSlotId, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }
    return -1;
  }

  handleClose = () => {
    this.props.reset();
    history.push("/dashboard");
  };

  handleContinue = () => {
    this.props.reset();
    this.multiStepRef.current.reset();
  };

  handleStepChanged = step => {
    this.setState({
      currentStep: step,
    });
  };

  render() {
    const header =
      this.state.currentStep === 0 ? messages.header : messages.thanks;

    return (
      <div>
        <AppContainer color="green" header={<FormattedMessage {...messages.title} />}>
          <ForegroundBlob fullscreen>
            <ModalHeader onClose={this.handleClose}>
              <FormattedMessage {...header} />
            </ModalHeader>
            <MultiStep
              currentStep={this.state.currentStep}
              ref={this.multiStepRef}
              stepProps={{
                timeSlotId: this.state.timeSlotId,
                onContinue: this.handleContinue,
              }}
              steps={[TimeSlotPlannerStep, TimeSlotResultStep]}
              onStepChange={this.handleStepChanged}
            />
          </ForegroundBlob>
        </AppContainer>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  timeSpanPlannerPage: makeSelectTimeSpanPlannerPage(),
});

function mapDispatchToProps(dispatch) {
  return {
    reset: () => dispatch(resetAction()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "timeSpanPlannerPage", reducer });
const withSaga = injectSaga({ key: "timeSpanPlannerPage", saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(TimeSlotPlanner);
